




































import { computed, defineComponent, onMounted } from '@vue/composition-api';
import { TranslateResult }                      from 'vue-i18n';
import { GlobalContexts, useGlobals }     from '@/hooks/use-globals';
import cBreadcrumb                        from '@/components/breadcrumb/breadcrumb.component.vue';
import CSwitch                            from '@/components/form/switch/switch.component.vue';
import CFooterPanel                       from '@/components/footer-panel/footer-panel.component.vue';

export default defineComponent({
  name: 'vChangelogSettings',
  components: {
    CFooterPanel,
    CSwitch,
    cBreadcrumb,
  },
  setup() {
    const { i18n, store }: GlobalContexts = useGlobals();
    const getTranslation = (path: string): TranslateResult => i18n.t(`vChangelogSettings.${path}`);
    const isLoading = computed((): boolean => store.state.views.vChangelogSettings.settingsLoading);
    const systemAutoAccept = computed((): boolean => store.state.views.vChangelogSettings.systemAutoAccept);
    const userAutoAccept = computed((): boolean => store.state.views.vChangelogSettings.userAutoAccept);

    const changeSystemConfiguration = () => {
      store.commit('views/vChangelogSettings/setSystemChangelogSettings', !systemAutoAccept.value);
    };

    const changeUserConfiguration = () => {
      store.commit('views/vChangelogSettings/setUserChangelogSettings', !userAutoAccept.value);
    };

    const saveConfiguration = (systemAutoAccept: boolean, userAutoAccept: boolean) => {
      const payload = {
        systemAutoAcceptEnabled: systemAutoAccept,
        userAutoAcceptEnabled: userAutoAccept,
      };
      store.dispatch('views/vChangelogSettings/putChangelogSettings', payload);
    };

    onMounted(() => {
      store.dispatch('views/vChangelogSettings/getChangelogSettings');
    });

    return {
      systemAutoAccept,
      userAutoAccept,
      isLoading,
      getTranslation,
      saveConfiguration,
      changeSystemConfiguration,
      changeUserConfiguration,
    };
  },
});
